export default __webpack_public_path__ + "static/media/addDish.b9dab1f7.svg";